import Backbone from "backbone";
import _ from "underscore";
import BaseControl from "./../base-control";
import template from "./property-template.html";
import DataSource from "./property-template-datasource";
import propertyTemplateService from "core/services/metaStoreService/property-template-service";
import propertyTemplateOverrides from "./property-template-overrides";
import $__app_components_common_editor_control_ui_control from "app/components/common/editor/control/ui-control";
import $__app_components_common_editor_form_builder from "app/components/common/editor/form-builder";
import copyPropertiesFrom from "./copy-properties/copy-properties-view";
import securityService from "core/services/securityService/securityService";
import growl from "app/components/common/growl";
import { addonFeaturesKeys } from "src/modules/user-plan/pages/user-plan/tabs/user-plan/components/add-on-features/add-on-features-utils";
import getControlResource from "../../../../common/editor/control-resource-resolver";
import FormBuilderMarionetteWrapper from "app/components/marionette-wrapper-for-react-form";
import FormBuilder, { TooltipComponent } from "src/generic/fd-form-builder/fd-form-builder";
import SegmentationLabel from "src/generic/fd-form-builder/segmentation-label.jsx";
import { FIELD_TYPES } from "@striim/striim-ui";
import { parseMapOrJsonUiConfig } from "../../../../../../src/generic/json-input/json-input.utils";
import MetaObjectConverter from "../../../../../../core/services/metaStoreService/metaobject-converter";
import {
    TABLE_SELECTION_SUPPORTED_SOURCES,
    TABLE_SELECTION_SUPPORTED_DB_PROVIDERS,
    ADAPTERS_WITH_PROVIDER_TYPE
} from "src/modules/flow-designer/vts/selectTables-utils";
import componentService from "core/services/componentService/component-service";
import { propertyTemplateUtils } from "core/utils/property-template-utils";
import dialog from "app/components/common/dialogs/dialogWindow";
import store from "src/stores/redux/store";
import { resetTestConnectionDataAction } from "src/stores/redux/features/sidebar/sidebar.slice";
import lastConnectionTestRepository from "app/components/common/editor/control/connection-text-field/last-connection-test-repository";

var View = BaseControl.View.extend({
    template: _.template(template),
    className: "property-template",
    disallowedControls: [],
    regions: {
        handlerRegion: ".handler",
        requiredPropertiesRegion: ".properties-required",
        optionalPropertiesRegion: ".properties-optional"
    },

    ui: {
        showHideProperties: ".show-hide-optional-properties"
    },

    events: {
        "click @ui.showHideProperties": "toggleOptionalProperties"
    },

    initialize: function() {
        this._UIControl = $__app_components_common_editor_control_ui_control;
        this._FormBuilder = $__app_components_common_editor_form_builder;
        this.firstLoad = true;
        this.currentValues = {};
        BaseControl.View.prototype.initialize.apply(this, arguments);

        const additionalAction = this._isAdditionalActionAvailable() ? "content_copy" : undefined;

        var property_templates_store = new DataSource(this.model.adapterType);
        this.propertySelect = this._UIControl
            .Select(property_templates_store, {
                showSelectionDescription: true,
                customViewOptions: this.customViewOptions,
                additionalAction: additionalAction,
                allowClear: false
            })
            .create();
    },

    setViewEnabled: function() {
        try {
            let propertySelectValue = this.propertySelect.getValue();
            var propertiesFromStore = propertyTemplateService.propertyTemplates.findWhere({
                id: propertySelectValue
            });
            this.renderForm(this.propertiesModel, propertiesFromStore, propertySelectValue);
        } catch (error) {
            console.log(error);
        }
        var enabled = this.getEnabled();
        this.propertySelect.setEnabled(enabled);
        this.propertySelect.showAdditionalAction(this._isAdditionalActionAvailable());

        if (this.options?.disableAdapterSelect) {
            this.propertySelect.setEnabled(false);
        }

        // condition to check if forms were created
        if (this.requiredFieldsForm) {
            this.requiredFieldsForm.setReadOnly(!enabled);
        }
        if (this.optionalFieldsForm) {
            this.optionalFieldsForm.setReadOnly(!enabled);
        }
    },

    refreshShowHideParameters: function(templateModel) {
        if (templateModel.get("handler")) {
            this.ui.showHideProperties.show().css("display", "inline-block");
        } else {
            this.ui.showHideProperties.hide();
        }
    },

    setDataSource: function(dataSource) {
        if (!dataSource || dataSource.length === 0 || !this.propertySelect) {
            return;
        }

        this.propertySelect.setDataSource(dataSource);
    },
    getSegmentationInfo: function(segmentationInfo, propertyName) {
        var segmentationResult = {
            disabled: false
        };
        const addonAvailable = securityService.isSegmentationFeatureEnabled(segmentationInfo);
        const variant = securityService.getSegmentationVariant(segmentationInfo);
        if (!addonAvailable) {
            segmentationResult.disabled = true;
            segmentationResult.label = (
                <SegmentationLabel licenseKey={segmentationInfo} label={propertyName} variant={variant} />
            );
        }
        return segmentationResult;
    },
    renderForm: function(propertiesModel, propertiesFromStore, selectedAdapter, forceRender = false) {
        try {
            if (!propertiesFromStore || _.isEmpty(propertiesModel)) {
                return;
            }

            // Stop rendering if the method is called by setViewEnabled
            // and the form is rendered with the same enabled value before
            const formEnabled = this?.options?.model?.enabled;
            if (this.formEnabled === formEnabled && !forceRender) {
                return;
            } else {
                this.formEnabled = formEnabled;
            }

            const that = this;
            const initialFieldValues = {};
            const resourceNamespace = propertiesFromStore?.id;
            const propertiesModelJson = propertiesModel.toJSON();
            const formattedPropertiesModelMap = new Map();

            // Loop - 1 required loop  - convert the keys to lowercase
            Object.keys(propertiesModelJson).forEach(key => {
                formattedPropertiesModelMap.set(key.toLowerCase(), propertiesModelJson[key]);
            });

            let databaseType = null;
            const propertyTemplatesToSetDefault = [
                "Global.PROPERTYTEMPLATE.DatabaseReader",
                "Global.PROPERTYTEMPLATE.DatabaseWriter",
                "Global.PROPERTYTEMPLATE.IncrementalBatchReader"
            ];
            if (propertyTemplatesToSetDefault.includes(this.model.get("value")?.handler)) {
                databaseType = "DEFAULT";
            }
            const propertyTemplateName = MetaObjectConverter.getName(resourceNamespace);

            const componentID = componentService.getComponentIDFromAdapterName(propertyTemplateName);
            // Get the correct property ket even if the key case is changed
            const model_keys_object = that._getPropertyKeyObjectForPropertyTemplateKey(
                propertiesFromStore?.propertyMap,
                propertiesModel
            );
            let jsonOrMapFields = {};

            //vts fields
            const handler = selectedAdapter || this.model.get("value")?.handler;
            const handlerDBType = handler?.split(".")?.pop();
            const isTableSelectionSupported = TABLE_SELECTION_SUPPORTED_SOURCES.includes(handlerDBType);
            const databaseProviderType = formattedPropertiesModelMap.get("databaseprovidertype");
            const isProviderUnsupported =
                ADAPTERS_WITH_PROVIDER_TYPE.includes(handlerDBType?.toUpperCase()) &&
                (!databaseProviderType || !TABLE_SELECTION_SUPPORTED_DB_PROVIDERS.includes(databaseProviderType));

            const hasVisualTableSelection = isTableSelectionSupported && !isProviderUnsupported;
            const baseTextAreaControls = hasVisualTableSelection
                ? ["template", "augumentqueryclause", "sobjects", "query", "excludedtables", "targettabledefinition"]
                : [
                      "template",
                      "tables",
                      "augumentqueryclause",
                      "sobjects",
                      "query",
                      "excludedtables",
                      "targettabledefinition"
                  ];

            // Loop-2 requied loop - Create field data for
            // form Builder form each property template field

            let formData = propertiesFromStore.propertyMap?.map(property => {
                let { defaultValue, type, name } = property;
                let ignoreProperty = false,
                    ignoreGrouping = false;

                var model_key = model_keys_object[name];
                var lincesePropertyName = that._getLicenseByPropertyName(model_key);

                if (!["handler", "adapterName", "parserName"].includes(name)) {
                    let formattedPropertyName = name.toLowerCase();
                    initialFieldValues[model_key] = formattedPropertiesModelMap.get(formattedPropertyName);
                }
                if (!property.required && property.conditionalRequired) {
                    property.required = property.conditionalRequired;
                }

                if (property.hasOwnProperty("uiconfig")) {
                    let value;
                    if (initialFieldValues[model_key] !== undefined) {
                        value = parseMapOrJsonUiConfig(jsonOrMapFields, property, initialFieldValues[model_key]);
                        value && (initialFieldValues[model_key] = value);
                    }
                    value = parseMapOrJsonUiConfig(jsonOrMapFields, property, defaultValue);
                    value && (defaultValue = value);
                }
                // returns {name,description}
                // converts the field name to a human readable string for label
                const controlResource = getControlResource(
                    name,
                    propertyTemplateName,
                    this.options?.sourceAdapters,
                    databaseType,
                    false,
                    componentID
                );

                let segmentationResult = {};

                if (lincesePropertyName) {
                    segmentationResult = that.getSegmentationInfo(lincesePropertyName, controlResource?.name);
                }

                if (type === "java.lang.Boolean" && typeof defaultValue === "string") {
                    defaultValue = defaultValue.toLowerCase() === "true";
                }

                if (type === "com.webaction.security.Password" || type === FIELD_TYPES.PASSWORD) {
                    type = FIELD_TYPES.PROPERTYTEMPLATE_PASSWORD;
                }

                let textAreaControls = baseTextAreaControls;

                if (hasVisualTableSelection) {
                    if (["tables", "zendeskobjects"].includes(name.toLowerCase())) {
                        type = FIELD_TYPES.SELECTTABLES;
                    } else if (name.toLowerCase() === "sobjects") {
                        textAreaControls = ["template", "augumentqueryclause"];
                        type = FIELD_TYPES.SELECTTABLES;
                    }
                }
                if (["tables"].includes(name.toLowerCase())) {
                    ignoreGrouping = !!hasVisualTableSelection;
                }
                if (["excludedtables", "query", "multiquery"].includes(name.toLowerCase())) {
                    ignoreProperty = !!hasVisualTableSelection;
                    ignoreGrouping = !!hasVisualTableSelection;
                }

                if (textAreaControls.includes(name.toLowerCase())) {
                    type = FIELD_TYPES.TEXTAREA;
                }

                return {
                    ...property,
                    name: model_key,
                    defaultValue: defaultValue,
                    label: controlResource?.name,
                    type: type,
                    ignoreProperty: ignoreProperty,
                    ignoreGrouping: ignoreGrouping,
                    disabled: !formEnabled,
                    additionalLabelcomponent: (
                        <TooltipComponent
                            data-test-id={`tooltip-${property?.name}`}
                            description={controlResource?.description}
                        />
                    ),
                    ...segmentationResult
                };
            });

            const formComponent = FormBuilderMarionetteWrapper(FormBuilder, {
                formFields: formData,
                propertiesModel: propertiesModel,
                initialValues: initialFieldValues,
                jsonOrMapFields: jsonOrMapFields,
                handler: selectedAdapter || this.model.get("value")?.handler,
                metaObjectId: that.options.metaObjectId,
                adapterType: that.options.model.get("adapterType"),
                isFormEnabled: this?.options?.model?.enabled,
                hasVisualTableSelection: hasVisualTableSelection,
                isCacheComponent: !!that.options.isCacheComponent
            });
            this.formComponent = formComponent;
            this.requiredPropertiesRegion.show(formComponent);
            this.currentFormHasVTS = hasVisualTableSelection;
        } catch (e) {
            console.log(e);
        }
    },

    onRender: function() {
        var that = this;
        this.propertiesModel = new Backbone.Model({});
        this.templateModel = new Backbone.Model(this.getValue());
        this.refreshShowHideParameters(this.templateModel);

        var templateSelectForm = new that._FormBuilder({
            model: that.templateModel,
            autoSave: true
        });

        function onPropertySelectValueChanged() {
            const newAdapter = that.propertySelect.getValue();
            const previousAdapter = that.templateModel.get("handler");

            if (that.currentFormHasVTS) {
                const propertiesJson = that.propertiesModel.toJSON();
                const keys = Object.keys(propertiesJson);
                const tablesKey = keys.find(k => k.toLowerCase() === "tables" || k.toLowerCase() === "sobjects");
                const queryKey = keys.find(k => k.toLowerCase() === "query");
                const multiqueryKey = keys.find(k => k.toLowerCase() === "multiquery");
                const hasTableSelections =
                    (tablesKey && !!propertiesJson[tablesKey]) ||
                    (queryKey && !!propertiesJson[queryKey]) ||
                    (multiqueryKey && !!propertiesJson[multiqueryKey]);
                if (hasTableSelections) {
                    that._interceptingAdapterChange = true;

                    const hasQueries = queryKey && !!propertiesJson[queryKey];
                    const title = hasQueries ? "Reset Queries" : "Reset Selected Tables";
                    const message = `You have ${
                        hasQueries ? "added queries" : "selected tables"
                    } in this source. Changing the properties will remove your previous selections.`;

                    dialog.confirm(message, null, "critical adapter-vts-reset-modal", title, "Reset").then(result => {
                        if (result) {
                            that._interceptingAdapterChange = false;
                            that.templateModel.unset("handler", { silent: true });
                            that._handlePropertyTemplateChange(newAdapter, true);
                        } else {
                            that.templateModel.set("handler", previousAdapter, { silent: true });
                            that.propertySelect.setValue(previousAdapter);
                            that._interceptingAdapterChange = false;
                        }
                    });
                    return;
                }
            }

            that._handlePropertyTemplateChange(newAdapter, true);
        }

        that.propertySelect.on(that._UIControl.EVENT.VALUE_CHANGED, onPropertySelectValueChanged);

        function onAdditionalAction() {
            let selectedValue = that.propertySelect.getViewValue();
            copyPropertiesFrom(selectedValue, that.options.metaObjectId)
                .then(component => {
                    let propertiesFromStore = propertyTemplateService.propertyTemplates.findWhere({
                        id: selectedValue
                    });
                    let componentProperties = component.properties;
                    let propertiesFromStoreJson = propertiesFromStore.toJSON().propertyMap;
                    propertiesFromStoreJson.forEach(property => {
                        if (property?.type?.toLowerCase().indexOf("password") !== -1) {
                            growl.info(
                                `For security reasons, property "${property?.name}" was not copied. Please enter the value manually.`,
                                "Password not copied",
                                that.options.metaObjectId
                            );
                            componentProperties[property.name] = "";
                        }
                    });
                    that.templateModel.clear();
                    that.propertiesModel.set(componentProperties);
                    that.renderForm(that.propertiesModel, propertiesFromStore, propertiesFromStore.get("id"), true);

                    return;
                })
                .catch(err => {
                    console.log(err);
                });
        }
        that.propertySelect.on("additional-action", onAdditionalAction);

        templateSelectForm.addRequiredControl(that.propertySelect, "handler", that.model.adapterType);
        var templateSelectionView = templateSelectForm.create();
        this.handlerRegion.show(templateSelectionView);
        onPropertySelectValueChanged();
        this.setValueFromView();
        that.trigger(this._UIControl.EVENT.VALUE_CHANGED, that.getValue());

        BaseControl.View.prototype.onRender.apply(this, arguments);
    },

    refreshFormForPrepopulatedValue: function() {
        var currentValue = this.getValue();
        if (currentValue && currentValue.handler) {
            var namespacedHandler = propertyTemplateUtils.addGlobalNamespace(currentValue.handler);

            this.propertySelect.setValue(namespacedHandler);

            setTimeout(() => {
                var propertySelectValue = this.propertySelect.getValue();
                this._handlePropertyTemplateChange(propertySelectValue, true);
            }, 100);
        }
    },

    _handlePropertyTemplateChange: function(propertySelectValue, forceRender = false) {
        var propertiesFromStore = propertyTemplateService.propertyTemplates.findWhere({
            id: propertySelectValue
        });

        if (propertiesFromStore) {
            // we cannot use model properties cause it's triggering change event that causes the form isDirty
            // flag to change to true and trigger the trackingWarnings
            this.requiresFormatter = propertiesFromStore.requiresFormatter;
            this.requiresParser = propertiesFromStore.requiresParser;
            propertyTemplateOverrides.process(propertiesFromStore);
        }

        if (this.templateModel.get("handler") === propertySelectValue) {
            this.propertiesModel.set(this.templateModel.get("properties"));
        } else {
            this.propertiesModel.clear({ silent: true });
            this.templateModel.clear({ silent: true });
            // Adapter changed — clear any cached Test Connection result so the new adapter's
            // banner starts from default. Redux survives the form rebuild that follows, and the
            // localStorage repository is what hydrates the banner on the next mount.
            store.dispatch(resetTestConnectionDataAction());
        }

        this.ui.showHideProperties.hide();
        this.renderForm(this.propertiesModel, propertiesFromStore, propertySelectValue, forceRender);
        this.propertySelect.showAdditionalAction(this._isAdditionalActionAvailable() && !!propertySelectValue);
    },

    _isAdditionalActionAvailable: function() {
        return this.model && this.model.adapterType !== "process" && this.getEnabled();
    },

    onShow: function() {
        this.templateModel.on(
            "change",
            function() {
                // templateSelectForm autoSave fires on value:set and sets templateModel.handler
                // before onPropertySelectValueChanged can intercept it. Skip setValueFromView
                // while the VTS reset modal is open so the outer form-builder does not mark
                // the component dirty until the user confirms or cancels.
                if (!this._interceptingAdapterChange) {
                    this.setValueFromView();
                }
            }.bind(this)
        );

        this.propertiesModel.on(
            "change",
            function(model, options) {
                if (!options.ignoreChange) {
                    this.templateModel.set("properties", this.propertiesModel.toJSON());
                }
            }.bind(this)
        );

        this.propertiesModel.on(
            "change:DatabaseProviderType",
            function() {
                const propertySelectValue = this.propertySelect.getValue();
                const propertiesFromStore = propertyTemplateService.propertyTemplates.findWhere({
                    id: propertySelectValue
                });
                this.renderForm(this.propertiesModel, propertiesFromStore, propertySelectValue, true);
            }.bind(this)
        );
        _.each(this.disallowedControls, control => {
            control.setEnabled(false);
            control.$el
                .closest(".field-row")
                .addClass("disabled")
                .prop("title", "Disabled due to License Restrictions.");
        });
    },

    _getLicenseByPropertyName: function(propertyName) {
        if (propertyName === "BiDirectionalMarkerTable") {
            return addonFeaturesKeys.BIDIRECTIONAL;
        }
        return undefined;
    },

    validate: async function() {
        const _this = this;

        if (_this.formComponent) {
            let errors = await _this.formComponent.validateForm();
            if (errors) {
                let dirtyFields = Object.keys(errors);
                return dirtyFields.length > 0 ? dirtyFields : false;
            }
        }

        return false;
    },

    getSelectedHandler: function() {
        return this.propertySelect.getValue();
    },

    getViewValue: function() {
        var value = this.templateModel.toJSON();
        if (!value.handler) {
            value.handler = this.propertySelect.getValue();
        }
        if (value && value.handler && !value.properties) {
            value.properties = {};
        }

        return value.handler ? value : {};
    },

    setViewValue: function() {},
    /**
     *
     * @param {*} propertyMap
     * @param {*} propertiesModel
     * @returns `{ propertyMapKey :propertyModelKey }[]`
     */
    _getPropertyKeyObjectForPropertyTemplateKey: function(propertyMap, propertiesModel) {
        const propertyModelMap = new Map();
        propertiesModel.keys().forEach(key => {
            propertyModelMap.set(key.toLowerCase(), key);
        });
        const propertyMapMap = new Map();
        propertyMap.forEach(property => {
            propertyMapMap.set(property.name, property.name.toLowerCase());
        });

        const resultObj = {};
        propertyMap.forEach(property => {
            const value = propertyMapMap.get(property.name);
            resultObj[property.name] = propertyModelMap.has(value) ? propertyModelMap.get(value) : property.name;
        });
        return resultObj;
    }
});

export default function(adapterType) {
    var Model = BaseControl.Model.extend({
        defaults: {
            adapterType: adapterType
        }
    });

    return _.extend({}, BaseControl, {
        Model: Model,
        View: View
    });
}
